'use strict';

import AiAlertTemplate from './template/AiAlertTemplate.vue';

const AlertModule = {
	install(Vue) {
		let AlertConstructor = Vue.extend(AiAlertTemplate);
		let alertInstance = null;

		const setAlertInstance = (options) => {
			if (alertInstance) {
				alertInstance.isVisible = true;
				Object.assign(alertInstance, options);
				return;
			}

			alertInstance = new AlertConstructor({
				el: document.createElement('div'),
				propsData: options
			});
		};

		const Alert = {
			alert: (title, content, primaryText = '확인') => {
				return new Promise((resolve) => {
					setAlertInstance({
						isVisible: true,
						title,
						content,
						primaryText,
						secondaryText: '',
						onClickPrimary: () => {
							resolve(true);
							Alert.close();
						}
					});
					document.body.appendChild(alertInstance.$el);
				});
			},
			//   confirm: (title, content, primaryText = '확인', secondaryText = '취소') => {
			//     return new Promise((resolve) => {
			//       setAlertInstance({
			//         isVisible: true,
			//         title,
			//         content,
			//         primaryText,
			//         secondaryText,
			//         onClickPrimary: () => {
			//           resolve(true);
			//           Alert.close();
			//         },
			//         onClickSecondary: () => {
			//           resolve(false);
			//           Alert.close();
			//         }
			//       });
			//       document.body.appendChild(alertInstance.$el);
			//     });
			//   },
			close: () => {
				if (alertInstance) {
					alertInstance.isVisible = false;
				}
			}
		};

		window.$AiAlert = Alert;
		Vue.AiAlert = Alert;
		Vue.prototype.$AiAlert = Alert;
	}
};

export default AlertModule;



// WEBPACK FOOTER //
// ./src/modules/aialert.js